import Cookies from 'js-cookie';

window.addEventListener('load', () => {
    // Function to add placeholders to HubSpot form inputs
    function addPlaceholdersToHubspotForms(hubspotForm) {
        const hubspotTextInputs = hubspotForm.querySelectorAll('.hs-form-field.hs-fieldtype-text, .hs-form-field.hs-fieldtype-textarea, .hs-fieldtype-phonenumber');

        for (const hubspotTextInput of hubspotTextInputs) {
            const labelText = hubspotTextInput.querySelector('label')?.textContent;
            const inputField = hubspotTextInput.querySelector('input, textarea');

            if (labelText && inputField) {
                inputField.placeholder = labelText;
            }
        }
    }

    function checkFooterAcceptCommunications(hubspotForm) {
        if (!hubspotForm) {
            console.error("HubSpot form not found.");
            return;
        }

        // Function to check and mark all consent checkboxes as checked
        function ensureCheckboxChecked() {
            const consentCheckboxes = hubspotForm.querySelectorAll('input[type="checkbox"][name^="LEGAL_CONSENT"]');

            let allChecked = true; // Flag to track if all checkboxes are already checked
            for (const consentCheckbox of consentCheckboxes) {
                if (!consentCheckbox.checked) {
                    consentCheckbox.checked = true; // Check the checkbox
                    allChecked = false; // Update flag if any checkbox was not checked
                }
            }

            // Clear interval if all checkboxes are checked
            if (allChecked) {
                clearInterval(checkInterval);
            }
        }

        // Set an interval to check every 3 seconds
        const checkInterval = setInterval(ensureCheckboxChecked, 500);

        // Optionally, stop the interval after a certain duration to avoid infinite loops
        setTimeout(() => clearInterval(checkInterval), 15000); // Stop after 15 seconds
    }


    function setFormHiddenValues(hubspotForm) {
        // Array of form fields and the new value that should be assigned to that field
        let formFields = [
            {
                handle: hubspotForm.utm_source,
                newValue: Cookies.get('utm_source')
            },
            {
                handle: hubspotForm.utm_medium,
                newValue: Cookies.get('utm_medium')
            },
            {
                handle: hubspotForm.utm_campaign,
                newValue: Cookies.get('utm_campaign')
            },
            {
                handle: hubspotForm.utm_content,
                newValue: Cookies.get('utm_content')
            },
            {
                handle: hubspotForm.gaclientid,
                newValue: Cookies.get('_ga')?.slice(6)
            },
            {
                handle: hubspotForm.gatrackid,
                newValue: typeof google_tag_manager === 'object' ? Object.keys(google_tag_manager).filter((key) => key.indexOf('G-') === 0) : ''
            },
            {
                handle: hubspotForm.gclid,
                newValue: Cookies.get('ff_gclid')
            },
            {
                handle: hubspotForm.page_url,
                newValue: window.location
            },
            {
                handle: hubspotForm.page_title,
                newValue: hubspotForm.closest('[data-page-title]').dataset.pageTitle ?? 'undefined'
            }
        ]

        // Assign form fields new values if they exist
        for (let field of formFields) {
            if (field.handle && field.newValue) {
                field.handle.value = field.newValue;
            }
        }
    }

    // Get all elements with the class .form-panel
    const formPanels = document.querySelectorAll('.form-panel, div[data-newsletter="inline"], div[data-blog-sbs-form-container]');

    // Iterate through each .form-panel to observe changes
    for (const formPanel of formPanels) {
        // Observe the .form-panel for dynamically added forms
        const observer = new MutationObserver((mutations, obs) => {
            for (const mutation of mutations) {
                // Loop through added nodes
                for (const node of mutation.addedNodes) {
                    if (node.nodeType === 1 && node.matches('form.hs-form-private')) {
                        addPlaceholdersToHubspotForms(node);
                        setFormHiddenValues(node);

                        if (node.closest('[data-newsletter="inline"]')) {
                            checkFooterAcceptCommunications(node);
                        }
                        // Disconnect the observer after processing
                        obs.disconnect();
                    }
                }
            }
        });

        // Start observing the specific .form-panel
        observer.observe(formPanel, { childList: true, subtree: true });

        // Initial call to check for already present forms
        const existingForms = formPanel.querySelectorAll('form.hs-form-private');
        existingForms.forEach((form) => addPlaceholdersToHubspotForms(form));
    }
});
